import styled from 'styled-components';

export const StyledAdminDropdownOption = styled.div`
  font-size: 1.6rem;
  font-weight: 400;
  line-height: 150%;
  cursor: pointer;

  &.current {
    color: ${(props) => (props.theme.id === 'dark' ? props.theme.accent2 : props.theme.text1)};
  }

  &:hover:not(.current) {
    color: ${(props) => props.theme.accent1};
  }

  @media screen and (max-width: 768px) {
    font-size: 1.2rem;
  }

  @media (min-width: 1000px) and (max-width: 1400px) {
    font-size: 1.4rem;
  }
`;
